/**
 * Reinitialize theme behaviors when sections load in the Shopify theme editor
 */
document.addEventListener('shopify:section:load', function (event) {
  if (window.KHTheme && typeof window.KHTheme.initFaqAccordions === 'function') {
    window.KHTheme.initFaqAccordions(event.target);
  }
  if (window.KHTheme && typeof window.KHTheme.initAuditLensTips === 'function') {
    window.KHTheme.initAuditLensTips(event.target);
  }
});

document.addEventListener('shopify:section:reorder', function (event) {
  if (window.KHTheme && typeof window.KHTheme.init === 'function') {
    window.KHTheme.init(event.target);
  }
});
